export default "__VITE_ASSET__Dy6b411y__"